export const OWNER = "Owner";
export const RECURLY_TOKEN = "RECURLY_TOKEN";
export const RECURLY_AMAZON = "RECURLY_AMAZON";
export const RECURLY_PAYPAL = "RECURLY_PAYPAL";
